import { IEvent, IObject, dispatcher, ingenuity } from "@quest/base-core";
import { ServerComm } from "@quest/platform-murka/dist";
import { EventConstantsLeander } from "@quest/oddsworks-platform/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "./GameParserModel";

export class GameServerComm extends ServerComm {
    /**
     * to add event listener for selection screen
     */
    protected bindEvent(): void {
        super.bindEvent();
        dispatcher.on(eventDispatchers.SEND_FREE_GAME_SELECTION_REQUEST, this.sendFreeGameSelectionRequest, this);
    }
    // Add to send free game selection request to server
    private sendFreeGameSelectionRequest(evt: IEvent): void {
        const selectedFreeSpin: string = evt.data;
        const freeGameSelectionData = this.getFreeGameSelectionRequest(selectedFreeSpin);
        dispatcher.fireEvent(EventConstantsLeander.SEND_REQUEST_TO_WRAPPER, freeGameSelectionData);
    }
    // get selection request object
    private getFreeGameSelectionRequest(freeSpins: string): IObject {
        const freeGameSelectionRequest: IObject = {};
        freeGameSelectionRequest.method = "placeBet";
        freeGameSelectionRequest.params = {};
        freeGameSelectionRequest.params.bet = 0;
        freeGameSelectionRequest.params.type = "bonus";
        freeGameSelectionRequest.params.params = {};
        freeGameSelectionRequest.params.params.linesPlayed = 100;
        freeGameSelectionRequest.params.params.playerChoice = freeSpins;
        const freeSpinSelectionRequestObject = [freeGameSelectionRequest, this.getBetResultRequest()];
        return freeSpinSelectionRequestObject;
    }
    protected sendBetRequest(): void {
        super.sendBetRequest();
        (ingenuity.parserModel as GameParserModel).setIsOutOfBalance(false);
    }
}